import React from 'react';
import { Check } from 'lucide-react';

interface Props {
  label: string;
  tone: string;
  on: boolean;
  disabled?: boolean;
  onClick: () => void;
  title?: string;
}

// A role as a pressable pill. The check mark means the state never depends on colour alone.
export default function RoleToggle({ label, tone, on, disabled, onClick, title }: Props) {
  return (
    <button
      type="button"
      aria-pressed={on}
      disabled={disabled}
      title={title}
      onClick={onClick}
      className={`inline-flex items-center gap-1 rounded-full px-2.5 py-1.5 text-xs font-medium ring-1 ring-inset transition-[transform,background-color,box-shadow] duration-150 ease-out active:scale-[0.96] disabled:opacity-60 motion-reduce:transition-none focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 ${
        on ? `${tone} font-semibold` : 'bg-white text-gray-600 ring-gray-200 hover:ring-gray-300 contrast-more:ring-gray-400'
      }`}
    >
      {on && <Check className="h-3 w-3" aria-hidden />}
      {label}
    </button>
  );
}
